import { getSapMaterials } from "@/modules/solrsearch";

const state = {
  items: [],
  limitRows: 50,
  loading: false,
  numFound: 0,
  searchString: ""
};

const getters = {};

const actions = {
  fetchSapMaterials: async ({ commit, rootState, state }, searchString) => {
    commit("setLoading", true);
    commit("clear");
    commit("setSearchString", searchString);

    const divisions = rootState.customer.additionalDivisionForSearch
      ? [
          rootState.customer.division,
          rootState.customer.additionalDivisionForSearch
        ]
      : [rootState.customer.division];

    const { d: response } = await getSapMaterials(
      rootState.customer.salesOrganisation,
      rootState.customer.distributionChannel,
      divisions,
      rootState.customer.productHierarchies || [],
      state.searchString,
      state.limitRows.toString()
    );
    commit("setSearchResult", response);
    commit("setLoading", false);
  }
};

const mutations = {
  changeItemQuantity: (state, { index, quantity }) => {
    state.items[index].quantity = Number.parseInt(quantity, 10) || 0;
  },
  clear: state => {
    state.searchString = "";
    state.numFound = 0;
    state.items = [];
  },
  setLoading: (state, value) => {
    state.loading = value;
  },
  setSearchResult: (state, { results }) => {
    state.numFound = results.length;
    state.items = results.map((item, index) => {
      return {
        category: item.item_category_group,
        description: item.material_description,
        id: index,
        materialNo: item.material_number,
        quantity: 1
      };
    });
  },
  setSearchString: (state, value) => {
    state.searchString = value.toString().trim();
  }
};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state
};
